import { trackEventTemplateThumbnailClick, trackEventTemplateThumbnailRecommendedClick } from "utils/gAnalyticsUtils";

import useUsers from "./useUsers";

const useTemplateGroupTracking = (templateGroup) => {
  const { currentUser } = useUsers();

  const trackClick = () => {
    trackEventTemplateThumbnailClick(templateGroup, currentUser);
  };

  const trackRecommended = () => {
    trackEventTemplateThumbnailRecommendedClick(templateGroup, currentUser);
  };

  return {
    trackClick,
    trackRecommended,
  };
};

export default useTemplateGroupTracking;
